import {Card, CardVariantType} from 'platform/components';
import {Box, Integer, Show, Text, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {useGetIntegrationCustomerQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {Nullish, openInNewTab} from 'shared/web';

interface BoschFleetIntegrationCardProps {
  customerId: string;
  subTitle?: string;
  cardVariant?: CardVariantType | Nullish;
  paddingTop?: Integer;
}

export function BoschFleetIntegrationCard(props: BoschFleetIntegrationCardProps) {
  const {customerId} = props;

  const {data: integrationCustomer, error} = useGetIntegrationCustomerQuery({customerId});

  const handleOpenTermsAndConditions = () => {
    if (integrationCustomer) {
      openInNewTab(integrationCustomer);
    }
  };

  const isBoshFleetClientWithoutPdf = isNotNil(error) && 'status' in error && error?.status === 404;

  return (
    <Show when={integrationCustomer || isBoshFleetClientWithoutPdf}>
      <Box paddingTop={props.paddingTop}>
        <VStack spacing={2}>
          <Show when={props.subTitle}>
            <Text size="small" color="secondary">
              {props.subTitle}
            </Text>
          </Show>
          <Card
            variant={props.cardVariant}
            colorStripe="blue"
            title={i18n.t('entity.customer.labels.boschFleet')}
            actions={[
              {
                type: 'button',
                variant: 'link',
                isDisabled: isBoshFleetClientWithoutPdf,
                rightIcon: 'action/open_in_new',
                onClick: handleOpenTermsAndConditions,
                title: i18n.t('entity.customer.labels.boschFleetTermsAndConditions'),
              },
            ]}
          />
        </VStack>
      </Box>
    </Show>
  );
}
